export enum KpiStatus {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  NEUTRAL = "neutral"
}
